export default __webpack_public_path__ + "static/media/s2.d14c8fb4.png";